export default __webpack_public_path__ + "static/favicon-1024x1024-with-padding--dev-7e03ac28da7cab68ead487f0b64b0c35.png";